// Copyright (c) Docugami, Inc. All rights reserved.

import { ChunkInstance } from "networking/api";
import { useMemo } from "react";
import { useAppSelector } from "./redux";
import { selectOrderedReportEntryIds, selectReportEntryBindingsForCurrentDocument } from "store/reports/selectors";
import { selectAllBindings } from "store/reports/reportsSlice";

export function useReportEntryIdForChunk(instance: string | null | ChunkInstance | undefined): string | undefined {
    const documentBindings = useAppSelector(selectReportEntryBindingsForCurrentDocument);
    const entryIds = useAppSelector(selectOrderedReportEntryIds);

    return useMemo(() => {
        if (!!instance && !!documentBindings) {
            const targetInstanceId = !!instance ? ((typeof instance === "string") ? instance : instance.spanId!) : undefined;
            if (!targetInstanceId) {
                return;
            }

            const target = selectAllBindings(documentBindings).find(x => !!x && !!entryIds?.includes(x.entryId) && !!x.bindings.find(y => targetInstanceId === y.spanId))
            return target?.entryId
        }
    }, [documentBindings, instance, entryIds])
}
